/*
 * Supported UI languages. This is the single place to add a language:
 *   1. add an entry here (enabled: false while it is being translated),
 *   2. run `npm run i18n:extract` - it creates empty catalogs under src/i18n/locales/<code>/,
 *   3. fill them (`npm run i18n:translate -- --lang <code>` or a translator), then
 *   4. add the AG Grid / date-picker locale imports in localeData.js and set enabled: true.
 *
 * English is the source language: its text lives in the code itself, so it needs no catalog,
 * and every missing translation falls back to it.
 *
 * NOTE: the i18n scripts parse this file with a regex - keep one `code: '..'` ... `enabled: ..` pair per entry.
 */
const LANGUAGES = [
    { code: 'en', enabled: true, name: 'English', nativeName: 'English', intl: 'en-GB', dir: 'ltr' },
    { code: 'it', enabled: true, name: 'Italian', nativeName: 'Italiano', intl: 'it-IT', dir: 'ltr' },
    { code: 'fr', enabled: true, name: 'French', nativeName: 'Français', intl: 'fr-FR', dir: 'ltr' },
    { code: 'de', enabled: true, name: 'German', nativeName: 'Deutsch', intl: 'de-DE', dir: 'ltr' },
    // Phase 2. Needs the RTL review described in docs/i18n.md before it can be enabled.
    { code: 'ar', enabled: false, name: 'Arabic', nativeName: 'العربية', intl: 'ar', dir: 'rtl' },
];

export const SOURCE_LANGUAGE = 'en';

export const ENABLED_LANGUAGES = LANGUAGES.filter(l => l.enabled);

export function findLanguage(code) {
    if (!code) return null;
    const base = String(code).toLowerCase().split(/[-_]/)[0];
    return ENABLED_LANGUAGES.find(l => l.code === base) || null;
}

export default LANGUAGES;
